import { axios } from '@/utils/request'

const api = {
    saiquList: '/adminapi/huiyi/saiquList',
    sjsqOptions: '/adminapi/huiyi/sjsqOptions',

    saiquDetail: '/adminapi/huiyi/saiquDetail',
    editSaiqu: '/adminapi/huiyi/editSaiqu',
    addSaiqu: '/adminapi/huiyi/addSaiqu',
    checkApplyOK: '/adminapi/huiyi/checkApplyOK',
    applyImport: '/adminapi/huiyi/applyImport',
    sendHuiyiMsg: '/adminapi/huiyi/sendHuiyiMsg',
    getHuiyiPhones: '/adminapi/huiyi/getHuiyiPhones',

    addHuiyiFile: '/adminapi/huiyi/filesadd',
    huiyiFileList: '/adminapi/huiyi/fileslist',
    deleteHuiyiFile: '/adminapi/huiyi/filesdelete',

    saijiList: '/adminapi/huiyi/saijiList',
    saijiDetail: '/adminapi/huiyi/saijiDetail',
    editSaiji: '/adminapi/huiyi/editSaiji',


    serviceTypeList: '/adminapi/huiyi/serviceTypeList',
    serviceTypeDetail: '/adminapi/huiyi/serviceTypeDetail',
    addServiceType: '/adminapi/huiyi/addServiceType',
    editServiceType: '/adminapi/huiyi/editServiceType',
    serviceTypeDelete: '/adminapi/huiyi/serviceTypeDelete',


    applyList: '/adminapi/huiyi/applyList',
    applyDetail: '/adminapi/huiyi/applyDetail',
    editApply: '/adminapi/huiyi/editApply',
    getApplyOrderDetail: '/adminapi/huiyi/applyOrderDetail',
    editApplyOrder: '/adminapi/huiyi/editApplyOrder',

    applySubjectList: '/adminapi/huiyi/applySubjectList',
    applySubjectDetail: '/adminapi/huiyi/applySubjectDetail',
    editApplySubject: '/adminapi/huiyi/editApplySubject',


    applyDelete: '/adminapi/huiyi/applyDelete',
    getSetting: '/adminapi/huiyi/getSetting',
    setSetting: '/adminapi/huiyi/setSetting',
    getApplyUserDetail: '/adminapi/huiyi/memberDetail',
    editApplyUser: '/adminapi/huiyi/applyMemberEdit',
    memberDelete: '/adminapi/huiyi/memberDelete',
    stationOptions: '/adminapi/huiyi/stationOptions',



    groupList: '/adminapi/huiyi/groupList',
    groupDetail: '/adminapi/huiyi/groupDetail',
    editGroup: '/adminapi/huiyi/editGroup',
    addGroup: '/adminapi/huiyi/addGroup',
    groupDelete: '/adminapi/huiyi/groupDelete',

    orderRefund: '/adminapi/huiyi/orderRefund',
    orderRefundApply: '/adminapi/huiyi/orderRefundApply',
    orderRefundRefuse: '/adminapi/huiyi/orderRefundRefuse',
    scoreImport: '/adminapi/huiyi/scoreImport',
    memberList: '/adminapi/huiyi/memberList',


    saiquApplyStep2Detail: '/adminapi/huiyi/saiquApplyStep2Detail',
    saiquApplyStep2Save: '/adminapi/huiyi/saiquApplyStep2Save',


    addSaiquApply: '/adminapi/huiyi/addSaiquApply',
    editSaiquApply: '/adminapi/huiyi/editSaiquApply',
    getSaiquApplyList: '/adminapi/huiyi/saiquApplyList',
    getSaiquApplyDetail: '/adminapi/huiyi/saiquApplyDetail',
    saiquApplyDelete: '/adminapi/huiyi/saiquApplyDelete',

    getXieyiList: '/adminapi/huiyi/xieyiList',
    addXieyiFile: '/adminapi/huiyi/addXieyiFile',
    editSaiquApplyOrder: '/adminapi/huiyi/editSaiquApplyOrder',
    saiquApplyOrderDetail: '/adminapi/huiyi/saiquApplyOrderDetail',



    getGoodsList: '/adminapi/huiyi/goodsList',
    deleteGoods: '/adminapi/huiyi/goodsDelete',
    setGoodsRank: '/adminapi/huiyi/setGoodsRank',
    setItemRank: '/adminapi/huiyi/setItemRank',
    editGoods: '/adminapi/huiyi/goodsEdit',
    addGoods: '/adminapi/huiyi/goodsAdd',
    getGoodsDetail: '/adminapi/huiyi/goodsDetail',
    getGoodsItemList: '/adminapi/huiyi/itemList',
    addItem: '/adminapi/huiyi/itemadd',
    editItem: '/adminapi/huiyi/itemedit',
    deleteItem: '/adminapi/huiyi/itemdelete',
    getItemDetail: '/adminapi/huiyi/itemDetail',
    getTypeOptions: '/adminapi/huiyi/getTypeOptions',

    // 发票
    fapiaoApply: '/adminapi/huiyi/fapiaoApply',
    getKaipiaoItemList: '/adminapi/huiyi/getKaipiaoItemList',
    fapiaoShenqingApply: '/adminapi/huiyi/fapiaoShenqingApply',




    addAdminUser: '/adminapi/huiyi/addAdminUser',
    deleteAdminUser: '/adminapi/huiyi/deleteAdminUser',
    getAdminUserList: '/adminapi/huiyi/adminUserList',



    addKaoguanUser: '/adminapi/huiyi/addKaoguanUser',
    deleteKaoguanUser: '/adminapi/huiyi/deleteKaoguanUser',
    getKaoguanUserList: '/adminapi/huiyi/kaoguanUserList',
}

export default api

export function getSaijiList(parameter) {
  return axios({
    url: api.saijiList,
    method: 'get',
    params: parameter
  })
}

export function getSaijiDetail(parameter) {
  return axios({
    url: api.saijiDetail,
    method: 'get',
    params: parameter
  })
}

export function editSaiji(parameter) {
  return axios({
    url: api.editSaiji,
    method: 'post',
    data: parameter
  })
}



export function getSaiquList(parameter) {
    return axios({
        url: api.saiquList,
        method: 'get',
        params: parameter
    })
}



export function getSaiquDetail(parameter) {
    return axios({
        url: api.saiquDetail,
        method: 'get',
        params: parameter
    })
}

export function editSaiqu(parameter) {
    return axios({
        url: api.editSaiqu,
        method: 'post',
        data: parameter
    })
}


export function addSaiqu(parameter) {
    return axios({
        url: api.addSaiqu,
        method: 'post',
        data: parameter
    })
}

export function addHuiyiFile(parameter) {
    return axios({
        url: api.addHuiyiFile,
        method: 'post',
        data: parameter
    })
}

export function getHuiyiFileList(parameter) {
    return axios({
        url: api.huiyiFileList,
        method: 'get',
        params: parameter
    })
}

export function deleteHuiyiFile(parameter) {
    return axios({
        url: api.deleteHuiyiFile,
        method: 'post',
        data: parameter
    })
}


export function getServiceTypeList(parameter) {
    return axios({
        url: api.serviceTypeList,
        method: 'get',
        params: parameter
    })
}


export function addServiceType(parameter) {
    return axios({
        url: api.addServiceType,
        method: 'post',
        data: parameter
    })
}

export function editServiceType(parameter) {
    return axios({
        url: api.editServiceType,
        method: 'post',
        data: parameter
    })
}
export function getServiceTypeDetail(parameter) {
    return axios({
        url: api.serviceTypeDetail,
        method: 'get',
        params: parameter
    })
}

export function serviceTypeDelete(parameter) {
    return axios({
        url: api.serviceTypeDelete,
        method: 'post',
        data: parameter
    })
}



export function getApplyList(parameter) {
    return axios({
        url: api.applyList,
        method: 'get',
        params: parameter
    })
}

export function getApplyDetail(parameter) {
    return axios({
        url: api.applyDetail,
        method: 'get',
        params: parameter
    })
}
export function editApply(parameter) {
    return axios({
        url: api.editApply,
        method: 'post',
        data: parameter
    })
}



export function getApplySubjectList(parameter) {
    return axios({
        url: api.applySubjectList,
        method: 'get',
        params: parameter
    })
}

export function applySubjectDetail(parameter) {
    return axios({
        url: api.applySubjectDetail,
        method: 'get',
        params: parameter
    })
}
export function editApplySubject(parameter) {
    return axios({
        url: api.editApplySubject,
        method: 'post',
        data: parameter
    })
}


export function applyDelete(parameter) {
    return axios({
        url: api.applyDelete,
        method: 'post',
        data: parameter
    })
}


export function subjectOptions(parameter) {
    return axios({
        url: api.subjectOptions,
        method: 'get',
        params: parameter
    })
}
export function startListOptions(parameter) {
    return axios({
        url: api.startListOptions,
        method: 'get',
        params: parameter
    })
}
export function getStartList(parameter) {
    return axios({
        url: api.getStartList,
        method: 'get',
        params: parameter
    })
}
export function getJiaolianList(parameter) {
    return axios({
        url: api.jiaolianList,
        method: 'get',
        params: parameter
    })
}
export function getCaipanList(parameter) {
    return axios({
        url: api.caipanList,
        method: 'get',
        params: parameter
    })
}
export function subjectMusicList(parameter) {
    return axios({
        url: api.subjectMusicList,
        method: 'get',
        params: parameter
    })
}
export function subjectMusicDetail(parameter) {
    return axios({
        url: api.subjectMusicDetail,
        method: 'get',
        params: parameter
    })
}
export function editSubjectMusic(parameter) {
    return axios({
        url: api.editSubjectMusic,
        method: 'post',
        data: parameter
    })
}
export function addSubjectMusic(parameter) {
    return axios({
        url: api.addSubjectMusic,
        method: 'post',
        data: parameter
    })
}
export function subjectMusicDelete(parameter) {
    return axios({
        url: api.subjectMusicDelete,
        method: 'post',
        params: parameter
    })
}


export function subjectTypeList(parameter) {
    return axios({
        url: api.subjectTypeList,
        method: 'get',
        params: parameter
    })
}
export function subjectTypeDetail(parameter) {
    return axios({
        url: api.subjectTypeDetail,
        method: 'get',
        params: parameter
    })
}
export function editSubjectType(parameter) {
    return axios({
        url: api.editSubjectType,
        method: 'post',
        data: parameter
    })
}
export function addSubjectType(parameter) {
    return axios({
        url: api.addSubjectType,
        method: 'post',
        data: parameter
    })
}
export function subjectTypeDelete(parameter) {
    return axios({
        url: api.subjectTypeDelete,
        method: 'post',
        params: parameter
    })
}


export function setSetting(parameter) {
    return axios({
        url: api.setSetting,
        method: 'post',
        params: parameter
    })
}

export function getSetting(parameter) {
    return axios({
        url: api.getSetting,
        method: 'post',
        params: parameter
    })
}


export function sjsqOptions(parameter) {
    return axios({
        url: api.sjsqOptions,
        method: 'post',
        params: parameter
    })
}
export function getApplyOrderDetail(parameter) {
    return axios({
        url: api.getApplyOrderDetail,
        method: 'post',
        data: parameter
    })
}

export function editApplyOrder(parameter) {
    return axios({
        url: api.editApplyOrder,
        method: 'post',
        data: parameter
    })
}

export function editApplyUser(parameter) {
    return axios({
        url: api.editApplyUser,
        method: 'post',
        data: parameter
    })
}
export function getApplyUserDetail(parameter) {
    return axios({
        url: api.getApplyUserDetail,
        method: 'post',
        data: parameter
    })
}
export function stationOptions(parameter) {
    return axios({
        url: api.stationOptions,
        method: 'post',
        data: parameter
    })
}
export function getGroupDetail(parameter) {
    return axios({
        url: api.groupDetail,
        method: 'post',
        data: parameter
    })
}
export function editGroup(parameter) {
    return axios({
        url: api.editGroup,
        method: 'post',
        data: parameter
    })
}
export function addGroup(parameter) {
    return axios({
        url: api.addGroup,
        method: 'post',
        data: parameter
    })
}

export function groupDelete(parameter) {
    return axios({
        url: api.groupDelete,
        method: 'post',
        data: parameter
    })
}


export function getGroupList(parameter) {
    return axios({
        url: api.groupList,
        method: 'get',
        params: parameter
    })
}

export function orderRefund(parameter) {
    return axios({
        url: api.orderRefund,
        method: 'get',
        params: parameter
    })
}

export function orderRefundApply(parameter) {
    return axios({
        url: api.orderRefundApply,
        method: 'get',
        params: parameter
    })
}

export function orderRefundRefuse(parameter) {
    return axios({
        url: api.orderRefundRefuse,
        method: 'get',
        params: parameter
    })
}

export function memberList(parameter) {
    return axios({
        url: api.memberList,
        method: 'get',
        params: parameter
    })
}


export function scoreImport(parameter) {
    return axios({
        url: api.scoreImport,
        method: 'post',
        headers: {
            'Content-Type':'multipart/form-data'
        },
        data: parameter
    })
}


export function saiquApplyStep2Detail(parameter) {
    return axios({
        url: api.saiquApplyStep2Detail,
        method: 'get',
        params: parameter
    })
}

export function addSaiquApply(parameter) {
    return axios({
        url: api.addSaiquApply,
        method: 'post',
        data: parameter
    })
}
export function editSaiquApply(parameter) {
    return axios({
        url: api.editSaiquApply,
        method: 'post',
        data: parameter
    })
}
export function getSaiquApplyList(parameter) {
    return axios({
        url: api.getSaiquApplyList,
        method: 'get',
        params: parameter
    })
}
export function getSaiquApplyDetail(parameter) {
    return axios({
        url: api.getSaiquApplyDetail,
        method: 'get',
        params: parameter
    })
}
export function addXieyiFile(parameter) {
    return axios({
        url: api.addXieyiFile,
        method: 'post',
        data: parameter
    })
}
export function getXieyiList(parameter) {
    return axios({
        url: api.getXieyiList,
        method: 'post',
        data: parameter
    })
}
export function saiquApplyDelete(parameter) {
    return axios({
        url: api.saiquApplyDelete,
        method: 'post',
        data: parameter
    })
}
export function saiquApplyStep2Save(parameter) {
    return axios({
        url: api.saiquApplyStep2Save,
        method: 'post',
        data: parameter
    })
}
export function editSaiquApplyOrder(parameter) {
    return axios({
        url: api.editSaiquApplyOrder,
        method: 'post',
        data: parameter
    })
}
export function getSaiquApplyOrderDetail(parameter) {
    return axios({
        url: api.saiquApplyOrderDetail,
        method: 'post',
        data: parameter
    })
}



export function getGoodsList(parameter) {
    return axios({
        url: api.getGoodsList,
        method: 'post',
        data: parameter
    })
}
export function deleteGoods(parameter) {
    return axios({
        url: api.deleteGoods,
        method: 'post',
        data: parameter
    })
}
export function setGoodsRank(parameter) {
    return axios({
        url: api.setGoodsRank,
        method: 'post',
        data: parameter
    })
}
export function setItemRank(parameter) {
    return axios({
        url: api.setItemRank,
        method: 'post',
        data: parameter
    })
}
export function editGoods(parameter) {
    return axios({
        url: api.editGoods,
        method: 'post',
        data: parameter
    })
}
export function addGoods(parameter) {
    return axios({
        url: api.addGoods,
        method: 'post',
        data: parameter
    })
}
export function getGoodsDetail(parameter) {
    return axios({
        url: api.getGoodsDetail,
        method: 'post',
        data: parameter
    })
}
export function getGoodsItemList(parameter) {
    return axios({
        url: api.getGoodsItemList,
        method: 'post',
        data: parameter
    })
}
export function addItem(parameter) {
    return axios({
        url: api.addItem,
        method: 'post',
        data: parameter
    })
}
export function editItem(parameter) {
    return axios({
        url: api.editItem,
        method: 'post',
        data: parameter
    })
}
export function deleteItem(parameter) {
    return axios({
        url: api.deleteItem,
        method: 'post',
        data: parameter
    })
}
export function getItemDetail(parameter) {
    return axios({
        url: api.getItemDetail,
        method: 'post',
        data: parameter
    })
}

export function fapiaoApply(parameter) {
    return axios({
        url: api.fapiaoApply,
        method: 'post',
        data: parameter
    })
}

export function getSaiquCashList(parameter) {
    return axios({
        url: '/adminapi/huiyi/saiquCashList',
        method: 'post',
        data: parameter
    })
}
export function cashSaiqu(parameter) {
    return axios({
        url: '/adminapi/huiyi/cashSaiqu',
        method: 'post',
        data: parameter
    })
}
export function getSaiquRewardList(parameter) {
    return axios({
        url: '/adminapi/huiyi/saiquRewardList',
        method: 'post',
        data: parameter
    })
}
export function rewardEdit(parameter) {
    return axios({
        url: '/adminapi/huiyi/rewardEdit',
        method: 'post',
        data: parameter
    })
}
export function getCashDetail(parameter) {
    return axios({
        url: '/adminapi/huiyi/rewardDetail',
        method: 'post',
        data: parameter
    })
}


export function onHuiyiReward(parameter) {
    return axios({
        url: '/adminapi/huiyi/onHuiyiReward',
        method: 'post',
        data: parameter
    })
}


export function memberDelete(parameter) {
    return axios({
        url: '/adminapi/huiyi/memberDelete',
        method: 'post',
        data: parameter
    })
}

export function fapiaoImport(parameter) {
    return axios({
        url: '/adminapi/huiyi/fapiaoImport',
        method: 'post',
        data: parameter
    })
}


export function getKaipiaoItemList(parameter) {
    return axios({
        url: api.getKaipiaoItemList,
        method: 'post',
        data: parameter
    })
}

export function fapiaoShenqingApply(parameter) {
    return axios({
        url: api.fapiaoShenqingApply,
        method: 'post',
        data: parameter
    })
}

export function checkApplyOK(parameter) {
    return axios({
        url: api.checkApplyOK,
        method: 'post',
        data: parameter
    })
}

export function applyImport(parameter) {
    return axios({
        url: api.applyImport,
        method: 'post',
        data: parameter
    })
}

export function getHuiyiPhones(parameter) {
    return axios({
        url: api.getHuiyiPhones,
        method: 'post',
        data: parameter
    })
}

export function sendHuiyiMsg(parameter) {
    return axios({
        url: api.sendHuiyiMsg,
        method: 'post',
        data: parameter
    })
}



export function addAdminUser(parameter) {
    return axios({
        url: 'adminapi/huiyi/addAdminUser',
        method: 'post',
        data: parameter
    })
}
export function deleteAdminUser(parameter) {
    return axios({
        url: 'adminapi/huiyi/deleteAdminUser',
        method: 'post',
        data: parameter
    })
}
export function getAdminUserList(parameter) {
    return axios({
        url: 'adminapi/huiyi/adminUserList',
        method: 'post',
        data: parameter
    })
}




export function addKaoguanUser(parameter) {
    return axios({
        url: 'adminapi/huiyi/addKaoguanUser',
        method: 'post',
        data: parameter
    })
}
export function deleteKaoguanUser(parameter) {
    return axios({
        url: 'adminapi/huiyi/deleteKaoguanUser',
        method: 'post',
        data: parameter
    })
}
export function getKaoguanUserList(parameter) {
    return axios({
        url: 'adminapi/huiyi/kaoguanUserList',
        method: 'post',
        data: parameter
    })
}